import { Grid } from "@mui/material";
import { GridProps } from "@mui/material/Grid";
import * as CSS from "csstype";
import * as React from "react";

interface IProps {
    alignSelf?: CSS.Property.JustifySelf;
    fullHeight?: boolean;
    fullWidth?: boolean;
    grow?: number;
    overflow?: CSS.Property.Overflow;
}

type Props = GridProps & IProps;

export const GridEx: React.FC<Props> = (props) => {
    const { alignSelf, children, fullHeight, fullWidth, grow, overflow, style, ...rest } = props;

    const s = style || {};
    if (grow) s["flexGrow"] = grow;
    if (fullWidth) s["width"] = "100%";
    if (fullHeight) s["height"] = "100%";
    if (alignSelf) s["alignSelf"] = alignSelf;
    if (overflow) s["overflow"] = overflow;

    return (
        <Grid {...rest} style={Object.keys(s).length == 0 ? null : s}>
            {children}
        </Grid>
    );
};
